import React from "react";
import "./styles.css";

/**
 * PricingTable – tabela flexível para exibir preços (ou outros atributos) dos modelos.
 *
 * Props:
 *   - pricing:  Array<Object>   // dados dos modelos
 *   - columns:  Array<{ label: string, key: string }>
 *
 * Extras:
 *   • Sempre exibe o `papayia_context_length` logo abaixo da célula do modelo (primeira coluna).
 */
const PricingTable = ({ pricing = [], columns = [] }) => {
    const formatUSD = (value) =>
        value === 0
            ? "-"
            : new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
                roundingMode: "trunc",
            }).format(value);

    const renderCell = (row, col) => {
        const value = row[col.key];

        // Primeira coluna (Model) – inclui context length e badges embaixo
        if (col.key === "papayia_model_id") {
            return (
                <td key={col.key}>
                    <div className="model-cell">
                        <span className="model-name">{value}</span>
                        {row.papayia_context_length && (
                            <span className="sub-note">
                                {row.papayia_context_length.toLocaleString()} ctx
                            </span>
                        )}
                        {row.typeProject && row.typeProject.length > 0 && (
                            <div className="badge-container">
                                {row.typeProject.map((type) => (
                                    <span key={type} className={`project-badge badge-${type}`}>
                                        {type}
                                    </span>
                                ))}
                            </div>
                        )}
                    </div>
                </td>
            );
        }

        // Valores numéricos (preços)
        if (typeof value === "number") {
            return (
                <td key={col.key} className="text-right">
                    <strong>{col.key.includes("price") ? formatUSD(value) : value}</strong>
                    <span className="sub-note"> / 1M Tokens</span>
                </td>
            );
        }

        // Default
        return <td key={col.key}>{value}</td>;
    };

    return (
        <div className="pricing-table-wrapper">
            <table className="pricing-table">
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th
                                key={col.key}
                                className={col.key.includes("price") ? "text-right" : undefined}
                            >
                                {col.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {pricing.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length} className="no-data">
                                No pricing data available
                            </td>
                        </tr>
                    ) : (
                        pricing.map((row) => (
                            <tr key={row.papayia_model_id || row.id}>
                                {columns.map((col) => renderCell(row, col))}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default PricingTable;
